export { FocusZone, FocusZoneDirection, FocusZoneTabbableElements } from '@fluentui/react-focus';
//# sourceMappingURL=FocusZone.js.map